import { WeightBasis } from '@freight-cbm/shared-types';

export function calcRevenueTon(
  totalCBM: number,
  grossWeightKg: number,
): { revenueTon: number; weightBasis: WeightBasis } {
  const volumeEquivalentKg = totalCBM * 1000; // 1 CBM = 1000 kg
  const revenueTon = Math.max(volumeEquivalentKg, grossWeightKg) / 1000;

  let weightBasis: WeightBasis;
  if (Math.abs(volumeEquivalentKg - grossWeightKg) < 0.001) {
    weightBasis = WeightBasis.Equal;
  } else if (grossWeightKg > volumeEquivalentKg) {
    weightBasis = WeightBasis.Actual;
  } else {
    weightBasis = WeightBasis.Dimensional; // volume-driven
  }

  return { revenueTon, weightBasis };
}
